<template>
  <div class="py-4 container-fluid">

    <div class=" row">
      <div class="col-12">
        <romaneio-table v-if="modo=='view'" :pedidos="rotas" :doUpdate="doUpdate" />
        <romaneio-relatorio v-if="modo=='relatorio'" :operacoes="operacoes" :rotas="rotas" :getRotasOperacao="getRotasOperacao" :doUpdate="doUpdate" />
        <loading  v-if="isLoading" />
      </div>
    </div>
  </div>
</template>

<script>


import { defineComponent, ref } from 'vue';


import RomaneioTable from "./components/RomaneioTable.vue";
import RomaneioRelatorio from "./components/RomaneioRelatorio.vue";
import ArgonButton from "@/components/ArgonButton.vue";

import Loading from "./components/Loading.vue";

import fintailapi from "../api";

export default defineComponent({
  name: "tables",
  components: {
    RomaneioTable,
    RomaneioRelatorio,
    ArgonButton,
    Loading
  },
  data() {
    return {
      map: null,
      google: null,
      data_sincroniza: {data_inicial:"", data_final:""},
      sincronizar: { show:false, progress:0 },
      modo : "view",
      rotas: [],
      operacoes:[],
      current_page:0,
      total_pages:0,
      isLoading:true
    };
  },
  async mounted() {
    
    this.getOperacoes()

  },
  methods: {
    doUpdate(event, pedido) {

    /*
        this.sincronizar.show = true
        this.sincronizar.progress = 20

        fintailapi
        .put(`/pedidos/${pedido.id_pedido}`,  pedido)
        .then((response) => {
            this.sincronizar.progress = 100
            this.sincronizar.show = false
        })
        .catch((error) => {
          this.sincronizar.show = false
          this.sincronizar.error = error.message
        })
*/

    },
    getOperacoes() {

                
      fintailapi
      .get(`/operacoes/rotas`)
      .then((response) => {

        this.operacoes = response.data.rows
        this.id_operacao = this.operacoes[0]
        this.getRotasOperacao(this.operacoes[0].id)

      })
      .catch((error) => {

      })

    },
    getRotas(offset) {
        this.isLoading = true
        fintailapi
        .get(`/rotas?offset=${offset}&limit=10`)
        .then((response) => {

          this.current_page = offset;

          this.rotas = response.data;

          this.isLoading = false
          //this.total_pages = response.data.count / 10

        })
        .catch((error) => {

          //this.isOpenRef = true;

        })

    },
    getRotasOperacao(id_operacao) {

      fintailapi
      .get(`/rotas/operacao/${id_operacao}`)
      .then(async(response) => {

        

        this.current_page = 0;

        this.rotas = response.data;

        this.isLoading = false




      })
      .catch((error) => {
        console.log(error)
        //this.isOpenRef = true;

      })

    },
  },
   created() {

      this.modo = this.$route.params.id || 'view';
      console.log( this.modo )


   },

});


</script>
